import linq from 'linq'
import { snakeToCamel, camelToSnake } from '../utility/stringUtility'
import Item from './Item'
import Product from './Product'
import Form from 'vform'
import Model from './Parents/Model'
import { arrayWrap } from '../utility/arrayUtitlity'

const FILLABEL = ['id', 'sort', 'productId', 'itemId']

const URL = '/api/product-recommend-item'
const LIST_URL = '/api/product-recommend-items'
const MODEL = 'ProductRecommendItem'

export default class ProductRecommendItem extends Model {
    constructor(data = null) {
        super()
        this.originalData = data

        this.id = 0
        this.sort = 0
        this.productId = 0
        this.itemId = 0

        this.product = new Product()
        this.item = new Item()

        this.form = new Form()

        if (data) {
            this.create()
        }
    }

    get _model() {
        return MODEL
    }

    get data() {
        return this.originalData
    }

    create() {
        linq.from(this.data)
            .select((x) => {
                x.key = camelToSnake(x.key)
                return x
            })
            .where((x) => this.hasOwnProperty(snakeToCamel(x.key)))
            .select((x) => {
                const key = snakeToCamel(x.key)

                if (key === 'item') {
                    this[key] = new Item(x.value)
                }

                if (key === 'product') {
                    this[key] = new Product(x.value)
                }

                this[key] = x.value
                return x
            })
            .toArray()
    }

    getPostable() {
        return linq
            .from(this)
            .where((x) => x.value)
            .where((x) => linq.from(FILLABEL).any((xs) => xs === x.key))
            .where((x) => x.value || typeof x.value === 'number')
            .select((x) => {
                const key = camelToSnake(x.key)
                return {
                    key: key,
                    value: x.value,
                }
            })
            .toObject('$.key', '$.value')
    }

    async getList(url) {
        url = url === undefined ? LIST_URL : url
        const { data } = await this.form.get(url + '/' + this.productId)
        return linq
            .from(data)
            .select((x) => new ProductRecommendItem(x))
            .toArray()
    }

    async add() {
        this.fill()
        return await this.form.post(URL)
    }

    async delete() {
        this.fill()
        return await this.form.delete(URL)
    }

    async update() {
        this.fill()
        return await this.form.patch(URL)
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/models/ProductRecommendItem.js